import React from 'react';
import { useTheme } from '../../theme/ThemeContext';

export default function PrimaryButton({ children, onClick, disabled, style, type = 'button' }) {
  const { theme } = useTheme();
  const isDark = theme.auth.containerBg === '#111827';
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        width: '100%',
        padding: '12px 16px',
        fontSize: 16,
        fontWeight: 600,
        letterSpacing: '0.3px',
        background: disabled 
          ? isDark ? '#666' : '#d0cdc8'
          : isDark
            ? 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)'
            : 'linear-gradient(135deg, #14b8a6 0%, #0f766e 100%)',
        color: theme.auth.buttonText,
        border: 'none',
        borderRadius: 10,
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: disabled 
          ? 'none'
          : isDark
            ? '0 8px 20px rgba(13, 148, 136, 0.3)'
            : '0 6px 18px rgba(15, 118, 110, 0.25)',
        opacity: disabled ? 0.7 : 1,
        ...style
      }}
      onMouseEnter={(e) => !disabled && (e.target.style.transform = 'translateY(-2px)', e.target.style.boxShadow = isDark ? '0 12px 28px rgba(13, 148, 136, 0.4)' : '0 10px 24px rgba(15, 118, 110, 0.3)')}
      onMouseLeave={(e) => !disabled && (e.target.style.transform = 'translateY(0)', e.target.style.boxShadow = isDark ? '0 8px 20px rgba(13, 148, 136, 0.3)' : '0 6px 18px rgba(15, 118, 110, 0.25)')}
    >
      {children}
    </button>
  );
}
